import api from "~/store/api"

export const listDocs = (data) => {
  return api.post("/docs/list", data).then((res) => res.data)
}

export const createDoc = (data) => {
  return api.post("/docs", data).then((res) => res.data.data)
}

export const getDoc = (id) => {
  return api.get(`/docs/${id}`).then((res) => res.data.data)
}

export const updateDoc = (data) => {
  const { id, ...rest } = data
  return api.post(`/docs/${id}`, rest).then((res) => res.data.data)
}

export const listTopics = (data) => {
  return api.get("/docs/topics", data).then((res) => res.data.data)
}
